import { useEffect, useMemo, useState } from 'react';
import { useAtomValue, useSetAtom } from 'jotai';
import { useParams } from 'react-router';

import { PermissionKey } from '../../services/PermissionAndRolesKeys';
import { PermissionService } from '../../services/PermissionService';
import { MultiPeriodReportingWrapper } from '../PortfolioOverview/MultiPeriodReporting/MultiperiodReporting';
import { selectedViewIdPFJ, viewsPFJ } from '../PortfolioOverview/state/ViewStateJ';
import { ViewTypeByData } from '../../data-models/view-config.data-model';

export function TempMprWrapper() {
  const ready = useSetViewId();

  if (!ready) {
    return null;
  }

  return <MultiPeriodReportingWrapper />;
}

function useSetViewId() {
  const setSelectedViewId = useSetAtom(selectedViewIdPFJ);
  const { viewId } = useParams();
  const [ready, setReady] = useState(false);

  useEffect(() => {
    if (ready || !viewId) {
      return;
    }
    const id = parseInt(viewId);
    if (isNaN(id)) {
      return;
    }
    setSelectedViewId(id);
    setReady(true);
  }, [viewId, setSelectedViewId, ready]);

  return ready;
}

export function getShowSeparateMprRoute() {
  return (
    PermissionService.get().hasPermission(PermissionKey.canViewMultiperiod) &&
    !PermissionService.get().hasPermission(PermissionKey.canViewMetrics)
  );
}

export function useGetDefaultMprView() {
  const views = useAtomValue(viewsPFJ);

  return useMemo(() => {
    if (!views) {
      return null;
    }
    return views.find((view) => view.isDefault && view.viewType === ViewTypeByData.multiperiod);
  }, [views]);
}
